import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as CalendarIcon } from "src/assets/static/images/calendaricon.svg";

const CustomDatePicker = ({ date, setDate, title }) => {
  const [showTitle, setShowTitle] = useState(false);
  const isActive = showTitle || date;

  return (
    <div className="main-profile-date-picker-container">
      <div
        className={`main-profile-floating-title ${isActive ? "active" : ""}`}
        onClick={() => setShowTitle(!showTitle)}
      >
        {title}
      </div>
      <DatePicker
        className={isActive ? "pt-3" : ""}
        selected={date}
        onChange={(currentDate) => setDate(currentDate)}
        onFocus={() => setShowTitle(true)}
        onBlur={() => setShowTitle(false)}
        placeholderText={isActive ? "" : title}
      />
      <CalendarIcon className="main-profile-calendar-icon-style" />
    </div>
  );
};

export default CustomDatePicker;
